import axios from 'axios';

export const getAuthHeader = (token: string) => {
  if (token) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
};

const PROFILE_REGEX = /\/profile\/profile\/\w+\?byUsername=true/;
const PROFILE_REQUEST_REGEX = /\/profile\/profile\/\w+/;
const LOGIN_REGEX = /\/login/;

async function AxiosInterceptors(auth: { userId: string; logout: () => Promise<void> }) {
  axios.interceptors.request.use((config) => {
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async function (error) {
      if (
        (error.response?.status >= 500 && error.response?.status < 600) ||
        (error.response?.status === 400 && error.response.data.errorType !== 'INVALID_USER_DATA') ||
        (error.request.responseURL.match(PROFILE_REGEX) !== null && error.response?.status === 404) ||
        (error.request.responseURL.match(PROFILE_REQUEST_REGEX) !== null &&
          Object.keys(JSON.parse(error.config.data)).every((v) => v === 'currency')) ||
        (error.response?.status === 403 && error.request.responseURL.match(LOGIN_REGEX) === null) ||
        error.request.responseURL === 'https://ipapi.co/currency/'
      ) {
        axios
          .post(`${import.meta.env.VITE_ERRORS_API_URI}`, {
            userDetails: {
              userId: auth.userId,
            },
            request: {
              requestLine: {
                method: error.config.method.toUpperCase(),
                uri: error.config.url,
              },
              requestBody: error.response.config.data,
            },
            response: {
              responseLine: {
                statusCode: error.response.status,
                statusMessage: error.response.statusText,
              },
              responseBody: JSON.stringify(error.response.data),
            },
          })
          .then(async () => {
            if (error.response?.status === 403) {
              await auth.logout();
              // navigate(FFM.LINKS.LOGIN);
              // });
            }
          })
          .catch(async () => {
            if (error.response?.status === 403) {
              await auth.logout(); //.then(() => {
              // navigate(FFM.LINKS.LOGIN);
              // });
            }
          });
      } else {
        if (error.response?.status === 403) {
          await auth.logout(); //.then(() => {
          // navigate(FFM.LINKS.LOGIN);
          // });
        }
      }

      return Promise.reject(error);
    },
  );
}

export default axios;
export { AxiosInterceptors };
